import { motion } from "framer-motion";

export default function PageHeader({ overline, title, subtitle }) {
  return (
    <section className="bg-navy text-white pt-32 md:pt-40 pb-16 md:pb-20 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-[0.05] pointer-events-none" />
      <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-brand-orange/20 blur-3xl pointer-events-none" />
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 relative">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="overline mb-6">{overline}</motion.p>
        <div className="overflow-hidden">
          <motion.h1
            initial={{ y: "110%" }} animate={{ y: "0%" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="font-display font-black text-5xl md:text-7xl tracking-tighter"
          >
            {title}
          </motion.h1>
        </div>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
            className="mt-6 text-white/70 text-lg max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
